module.exports = __webpack_public_path__ + "5f6073be9720bcaa676aa0cda05a383f.mp3";


//////////////////
// WEBPACK FOOTER
// ./sounds/child.mp3
// module id = 825
// module chunks = 0